// import React, { useState, useEffect } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   getAuth,
//   createUserWithEmailAndPassword,
//   signInWithEmailAndPassword,
//   signInWithPopup,
//   GoogleAuthProvider,
//   sendPasswordResetEmail,
// } from "firebase/auth";
// import axios from "axios";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { auth } from "../firebaseConfig";
// import { CONSTANTS } from "../constants/Constants";

// const AuthPage = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [activeTab, setActiveTab] = useState(
//     location.pathname === "/register" ? "register" : "login"
//   );
//   const [rememberMe, setRememberMe] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [passwordStrength, setPasswordStrength] = useState(0);
//   const [passwordsMatch, setPasswordsMatch] = useState(true);
//   const googleProvider = new GoogleAuthProvider();

//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: "",
//     loginEmail: "",
//     loginPassword: "",
//   });
//   const [formErrors, setFormErrors] = useState({});

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [activeTab]);

//   // Update URL based on active tab without reload
//   useEffect(() => {
//     const path = activeTab === "register" ? "/register" : "/login";
//     if (location.pathname !== path) {
//       window.history.pushState({}, "", path);
//     }
//   }, [activeTab, location.pathname]);

//   // Check password strength
//   useEffect(() => {
//     if (!formData.password) {
//       setPasswordStrength(0);
//       return;
//     }

//     let strength = 0;
//     if (formData.password.length >= 8) strength += 1;
//     if (/[A-Z]/.test(formData.password)) strength += 1;
//     if (/[0-9]/.test(formData.password)) strength += 1;
//     if (/[^A-Za-z0-9]/.test(formData.password)) strength += 1;

//     setPasswordStrength(strength);
//   }, [formData.password]);

//   // Check if passwords match
//   useEffect(() => {
//     if (formData.confirmPassword) {
//       setPasswordsMatch(formData.password === formData.confirmPassword);
//     }
//   }, [formData.password, formData.confirmPassword]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });

//     // Clear error for this field when user starts typing again
//     if (formErrors[name]) {
//       setFormErrors({
//         ...formErrors,
//         [name]: "",
//       });
//     }
//   };

//   const validateLoginForm = () => {
//     const errors = {};
//     if (!formData.loginEmail) errors.loginEmail = "Email is required";
//     if (!formData.loginPassword) errors.loginPassword = "Password is required";

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const validateRegisterForm = () => {
//     const errors = {};
//     if (!formData.firstName) errors.firstName = "First name is required";
//     if (!formData.lastName) errors.lastName = "Last name is required";
//     if (!formData.email) errors.email = "Email is required";
//     if (!formData.phone) errors.phone = "Phone number is required";
//     if (!formData.password) errors.password = "Password is required";
//     if (formData.password.length < 8)
//       errors.password = "Password must be at least 8 characters";
//     if (passwordStrength < 3) errors.password = "Password is too weak";
//     if (!formData.confirmPassword)
//       errors.confirmPassword = "Please confirm your password";
//     if (formData.password !== formData.confirmPassword)
//       errors.confirmPassword = "Passwords do not match";

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleForgotPassword = async () => {
//     if (!formData.loginEmail) {
//       setFormErrors({ ...formErrors, loginEmail: "Please enter your email" });
//       return;
//     }

//     try {
//       setIsLoading(true);
//       await sendPasswordResetEmail(auth, formData.loginEmail);
//       toast.success("Password reset email sent! Check your inbox.");
//     } catch (error) {
//       toast.error("Failed to send reset email: " + error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleLoginSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateLoginForm()) return;

//     try {
//       setIsLoading(true);

//       // Sign in with Firebase
//       const userCredential = await signInWithEmailAndPassword(
//         auth,
//         formData.loginEmail,
//         formData.loginPassword
//       );

//       const user = userCredential.user;

//       // Fetch additional user data from MongoDB

//       const response = await axios.get(
//         `${CONSTANTS.APIURL}/api/users/${user.uid}`
//       );

//       // Store user data in localStorage or context
//       if (rememberMe) {
//         localStorage.setItem(
//           "user",
//           JSON.stringify({
//             uid: user.uid,
//             email: user.email,
//             ...response.data,
//           })
//         );
//       } else {
//         sessionStorage.setItem(
//           "user",
//           JSON.stringify({
//             uid: user.uid,
//             email: user.email,
//             ...response.data,
//           })
//         );
//       }

//       toast.success("Login successful!");

//       // Redirect to dashboard
//       setTimeout(() => {
//         navigate("/");
//       }, 1500);
//     } catch (error) {
//       console.error("Login error:", error);

//       let errorMessage = "Failed to sign in";
//       if (error.code === "auth/invalid-email") {
//         errorMessage = "Invalid email address";
//       } else if (error.code === "auth/invalid-credential") {
//         errorMessage = "Invalid email or password";
//       } else if (error.code === "auth/too-many-requests") {
//         errorMessage = "Too many attempts. Try again later";
//       }

//       toast.error(errorMessage);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleGoogleSignIn = async () => {
//     try {
//       setIsLoading(true);

//       // Sign in with Google
//       const result = await signInWithPopup(auth, googleProvider);
//       const user = result.user;

//       // Check if user exists in our database
//       try {
//         await axios.get(`${CONSTANTS.APIURL}/api/users/${user.uid}`);
//       } catch (error) {
//         if (error.response && error.response.status === 404) {
//           // User doesn't exist, create new user in MongoDB
//           const userData = {
//             uid: user.uid,
//             firstName: user.displayName ? user.displayName.split(" ")[0] : "",
//             lastName: user.displayName
//               ? user.displayName.split(" ").slice(1).join(" ")
//               : "",
//             email: user.email,
//             phone: user.phoneNumber || "N/A",
//             authProvider: "google",
//             createdAt: new Date(),
//           };

//           await axios.post(`${CONSTANTS.APIURL}/api/users`, userData);
//         }
//       }

//       // Store user data
//       localStorage.setItem(
//         "user",
//         JSON.stringify({
//           uid: user.uid,
//           email: user.email,
//           firstName: user.displayName ? user.displayName.split(" ")[0] : "",
//           lastName: user.displayName
//             ? user.displayName.split(" ").slice(1).join(" ")
//             : "",
//           photoURL: user.photoURL,
//         })
//       );

//       toast.success("Login successful!");

//       // Redirect to dashboard
//       setTimeout(() => {
//         navigate("/");
//       }, 1500);
//     } catch (error) {
//       console.error("Google sign-in error:", error);
//       toast.error("Failed to sign in with Google: " + error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleRegisterSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateRegisterForm()) return;

//     try {
//       setIsLoading(true);

//       // Create user in Firebase
//       const userCredential = await createUserWithEmailAndPassword(
//         auth,
//         formData.email,
//         formData.password
//       );

//       const user = userCredential.user;

//       // Create user in MongoDB
//       const userData = {
//         uid: user.uid,
//         firstName: formData.firstName,
//         lastName: formData.lastName,
//         email: formData.email,
//         phone: formData.phone,
//         authProvider: "email",
//         createdAt: new Date(),
//       };

//       await axios.post(`${CONSTANTS.APIURL}/api/users`, userData);

//       toast.success("Account created successfully!");

//       // Automatically log in and redirect
//       setTimeout(() => {
//         setActiveTab("login");
//         setFormData({
//           ...formData,
//           loginEmail: formData.email,
//           loginPassword: formData.password,
//         });
//       }, 1500);
//     } catch (error) {
//       console.error("Registration error:", error);

//       let errorMessage = "Failed to create account";
//       if (error.code === "auth/email-already-in-use") {
//         errorMessage = "Email already in use";
//       } else if (error.code === "auth/invalid-email") {
//         errorMessage = "Invalid email address";
//       } else if (error.code === "auth/weak-password") {
//         errorMessage = "Password is too weak";
//       }

//       toast.error(errorMessage);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Password strength indicator component
//   const PasswordStrengthIndicator = () => {
//     const strengthLabels = ["Weak", "Fair", "Good", "Strong"];
//     const strengthColors = ["#f87171", "#fbbf24", "#34d399", "#60a5fa"];

//     return (
//       <div className="mt-1">
//         <div className="w-full h-1 bg-gray-200 rounded-full overflow-hidden">
//           <div
//             className="h-full transition-all duration-300 ease-in-out"
//             style={{
//               width: `${(passwordStrength / 4) * 100}%`,
//               backgroundColor:
//                 strengthColors[passwordStrength - 1] || "#f3f4f6",
//             }}
//           />
//         </div>
//         {formData.password && (
//           <p
//             className="text-xs mt-1"
//             style={{ color: strengthColors[passwordStrength - 1] || "#6b7280" }}
//           >
//             {passwordStrength > 0
//               ? strengthLabels[passwordStrength - 1]
//               : "Too weak"}
//           </p>
//         )}
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen bg-gray-100 pt-4 pb-12">
//       <ToastContainer position="top-right" autoClose={3000} />

//       {/* Main Content */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex flex-col items-center justify-center">
//           {/* Logo and Header */}
//           <div className="text-center mb-8">
//             <img
//               src="/images/npsc-logo.png"
//               alt="NPSC Coaching"
//               className="h-16 mx-auto"
//             />
//             <h1 className="mt-6 text-3xl font-bold text-gray-800">
//               {activeTab === "login" ? "Welcome Back" : "Create Account"}
//             </h1>
//             <p className="mt-3 text-gray-600 max-w-lg">
//               {activeTab === "login"
//                 ? "Sign in to access your dashboard, study materials, and test series."
//                 : "Join our community of successful NPSC aspirants."}
//             </p>
//           </div>

//           {/* Auth Card */}
//           <div className="w-full max-w-5xl">
//             <motion.div
//               className="bg-white rounded-xl shadow-lg overflow-hidden"
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               <div className="md:grid md:grid-cols-5">
//                 {/* Left side - Form */}
//                 <div className="md:col-span-3 p-6 sm:p-10">
//                   {/* Tab Switcher */}
//                   <div className="flex border-b border-gray-200 mb-8">
//                     <button
//                       className={`py-4 px-6 text-center font-medium text-lg transition-colors relative ${
//                         activeTab === "login"
//                           ? "text-gray-800"
//                           : "text-gray-500 hover:text-gray-700"
//                       }`}
//                       onClick={() => setActiveTab("login")}
//                       disabled={isLoading}
//                     >
//                       Login
//                       {activeTab === "login" && (
//                         <motion.div
//                           className="absolute bottom-0 left-0 right-0 h-0.5 bg-gray-800"
//                           layoutId="activeTab"
//                         />
//                       )}
//                     </button>
//                     <button
//                       className={`py-4 px-6 text-center font-medium text-lg transition-colors relative ${
//                         activeTab === "register"
//                           ? "text-gray-800"
//                           : "text-gray-500 hover:text-gray-700"
//                       }`}
//                       onClick={() => setActiveTab("register")}
//                       disabled={isLoading}
//                     >
//                       Register
//                       {activeTab === "register" && (
//                         <motion.div
//                           className="absolute bottom-0 left-0 right-0 h-0.5 bg-gray-800"
//                           layoutId="activeTab"
//                         />
//                       )}
//                     </button>
//                   </div>

//                   <AnimatePresence mode="wait">
//                     <motion.div
//                       key={activeTab}
//                       initial={{
//                         opacity: 0,
//                         x: activeTab === "login" ? -20 : 20,
//                       }}
//                       animate={{ opacity: 1, x: 0 }}
//                       exit={{ opacity: 0, x: activeTab === "login" ? 20 : -20 }}
//                       transition={{ duration: 0.3 }}
//                     >
//                       {/* Login Form */}
//                       {activeTab === "login" && (
//                         <form
//                           onSubmit={handleLoginSubmit}
//                           className="space-y-6"
//                         >
//                           <div>
//                             <label
//                               htmlFor="loginEmail"
//                               className="block text-sm font-medium text-gray-700"
//                             >
//                               Email Address
//                             </label>
//                             <div className="mt-1">
//                               <input
//                                 id="loginEmail"
//                                 name="loginEmail"
//                                 type="email"
//                                 autoComplete="email"
//                                 required
//                                 value={formData.loginEmail}
//                                 onChange={handleInputChange}
//                                 className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 sm:text-sm transition-colors
//                                   ${
//                                     formErrors.loginEmail
//                                       ? "border-red-500"
//                                       : "border-gray-300"
//                                   }`}
//                                 placeholder="your.email@example.com"
//                                 disabled={isLoading}
//                               />
//                               {formErrors.loginEmail && (
//                                 <p className="mt-1 text-sm text-red-600">
//                                   {formErrors.loginEmail}
//                                 </p>
//                               )}
//                             </div>
//                           </div>

//                           <div>
//                             <div className="flex items-center justify-between">
//                               <label
//                                 htmlFor="loginPassword"
//                                 className="block text-sm font-medium text-gray-700"
//                               >
//                                 Password
//                               </label>
//                               <button
//                                 type="button"
//                                 onClick={handleForgotPassword}
//                                 className="text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors"
//                                 disabled={isLoading}
//                               >
//                                 Forgot password?
//                               </button>
//                             </div>
//                             <div className="mt-1 relative">
//                               <input
//                                 id="loginPassword"
//                                 name="loginPassword"
//                                 type={showPassword ? "text" : "password"}
//                                 autoComplete="current-password"
//                                 required
//                                 value={formData.loginPassword}
//                                 onChange={handleInputChange}
//                                 className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 sm:text-sm transition-colors
//                                   ${
//                                     formErrors.loginPassword
//                                       ? "border-red-500"
//                                       : "border-gray-300"
//                                   }`}
//                                 placeholder="••••••••"
//                                 disabled={isLoading}
//                               />
//                               <button
//                                 type="button"
//                                 onClick={() => setShowPassword(!showPassword)}
//                                 className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
//                               >
//                                 {showPassword ? (
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     className="h-5 w-5"
//                                     viewBox="0 0 20 20"
//                                     fill="currentColor"
//                                   >
//                                     <path
//                                       fillRule="evenodd"
//                                       d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z"
//                                       clipRule="evenodd"
//                                     />
//                                     <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
//                                   </svg>
//                                 ) : (
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     className="h-5 w-5"
//                                     viewBox="0 0 20 20"
//                                     fill="currentColor"
//                                   >
//                                     <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
//                                     <path
//                                       fillRule="evenodd"
//                                       d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
//                                       clipRule="evenodd"
//                                     />
//                                   </svg>
//                                 )}
//                               </button>
//                               {formErrors.loginPassword && (
//                                 <p className="mt-1 text-sm text-red-600">
//                                   {formErrors.loginPassword}
//                                 </p>
//                               )}
//                             </div>
//                           </div>

//                           <div className="flex items-center justify-between">
//                             <div className="flex items-center">
//                               <input
//                                 id="remember-me"
//                                 name="remember-me"
//                                 type="checkbox"
//                                 checked={rememberMe}
//                                 onChange={(e) =>
//                                   setRememberMe(e.target.checked)
//                                 }
//                                 className="h-4 w-4 text-gray-700 focus:ring-gray-500 border-gray-300 rounded"
//                                 disabled={isLoading}
//                               />
//                               <label
//                                 htmlFor="remember-me"
//                                 className="ml-2 block text-sm text-gray-700"
//                               >
//                                 Remember me
//                               </label>
//                             </div>
//                           </div>

//                           <div>
//                             <button
//                               type="submit"
//                               className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-md text-base font-medium text-white bg-gray-800 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-600 transition-colors"
//                               disabled={isLoading}
//                             >
//                               {isLoading ? (
//                                 <svg
//                                   className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   fill="none"
//                                   viewBox="0 0 24 24"
//                                 >
//                                   <circle
//                                     className="opacity-25"
//                                     cx="12"
//                                     cy="12"
//                                     r="10"
//                                     stroke="currentColor"
//                                     strokeWidth="4"
//                                   ></circle>
//                                   <path
//                                     className="opacity-75"
//                                     fill="currentColor"
//                                     d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                                   ></path>
//                                 </svg>
//                               ) : null}
//                               Sign in
//                             </button>
//                           </div>

//                           <div className="mt-6">
//                             <div className="relative">
//                               <div className="absolute inset-0 flex items-center">
//                                 <div className="w-full border-t border-gray-300" />
//                               </div>
//                               <div className="relative flex justify-center text-sm">
//                                 <span className="px-2 bg-white text-gray-500">
//                                   Or continue with
//                                 </span>
//                               </div>
//                             </div>

//                             <div className="mt-6">
//                               <button
//                                 type="button"
//                                 onClick={handleGoogleSignIn}
//                                 className="w-full inline-flex justify-center py-3 px-4 border border-gray-300 rounded-lg shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
//                                 disabled={isLoading}
//                               >
//                                 <svg
//                                   className="h-5 w-5 text-[#4285F4]"
//                                   fill="currentColor"
//                                   viewBox="0 0 24 24"
//                                 >
//                                   <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
//                                 </svg>
//                                 <span className="ml-2">
//                                   Sign in with Google
//                                 </span>
//                               </button>
//                             </div>
//                           </div>

//                           <div className="mt-6 text-center">
//                             <p className="text-sm text-gray-600">
//                               Don't have an account?{" "}
//                               <button
//                                 type="button"
//                                 onClick={() => setActiveTab("register")}
//                                 className="font-medium text-gray-800 hover:text-gray-900 underline"
//                                 disabled={isLoading}
//                               >
//                                 Register now
//                               </button>
//                             </p>
//                           </div>
//                         </form>
//                       )}

//                       {/* Register Form */}
//                       {activeTab === "register" && (
//                         <form
//                           onSubmit={handleRegisterSubmit}
//                           className="space-y-6"
//                         >
//                           <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
//                             <div>
//                               <label
//                                 htmlFor="firstName"
//                                 className="block text-sm font-medium text-gray-700"
//                               >
//                                 First Name
//                               </label>
//                               <div className="mt-1">
//                                 <input
//                                   id="firstName"
//                                   name="firstName"
//                                   type="text"
//                                   autoComplete="given-name"
//                                   required
//                                   value={formData.firstName}
//                                   onChange={handleInputChange}
//                                   className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 sm:text-sm transition-colors
//                                     ${
//                                       formErrors.firstName
//                                         ? "border-red-500"
//                                         : "border-gray-300"
//                                     }`}
//                                   placeholder="John"
//                                   disabled={isLoading}
//                                 />
//                                 {formErrors.firstName && (
//                                   <p className="mt-1 text-sm text-red-600">
//                                     {formErrors.firstName}
//                                   </p>
//                                 )}
//                               </div>
//                             </div>

//                             <div>
//                               <label
//                                 htmlFor="lastName"
//                                 className="block text-sm font-medium text-gray-700"
//                               >
//                                 Last Name
//                               </label>
//                               <div className="mt-1">
//                                 <input
//                                   id="lastName"
//                                   name="lastName"
//                                   type="text"
//                                   autoComplete="family-name"
//                                   required
//                                   value={formData.lastName}
//                                   onChange={handleInputChange}
//                                   className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 sm:text-sm transition-colors
//                                     ${
//                                       formErrors.lastName
//                                         ? "border-red-500"
//                                         : "border-gray-300"
//                                     }`}
//                                   placeholder="Doe"
//                                   disabled={isLoading}
//                                 />
//                                 {formErrors.lastName && (
//                                   <p className="mt-1 text-sm text-red-600">
//                                     {formErrors.lastName}
//                                   </p>
//                                 )}
//                               </div>
//                             </div>
//                           </div>

//                           <div>
//                             <label
//                               htmlFor="email"
//                               className="block text-sm font-medium text-gray-700"
//                             >
//                               Email Address
//                             </label>
//                             <div className="mt-1">
//                               <input
//                                 id="email"
//                                 name="email"
//                                 type="email"
//                                 autoComplete="email"
//                                 required
//                                 value={formData.email}
//                                 onChange={handleInputChange}
//                                 className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 sm:text-sm transition-colors
//                                   ${
//                                     formErrors.email
//                                       ? "border-red-500"
//                                       : "border-gray-300"
//                                   }`}
//                                 placeholder="your.email@example.com"
//                                 disabled={isLoading}
//                               />
//                               {formErrors.email && (
//                                 <p className="mt-1 text-sm text-red-600">
//                                   {formErrors.email}
//                                 </p>
//                               )}
//                             </div>
//                           </div>

//                           <div>
//                             <label
//                               htmlFor="phone"
//                               className="block text-sm font-medium text-gray-700"
//                             >
//                               Phone Number
//                             </label>
//                             <div className="mt-1">
//                               <input
//                                 id="phone"
//                                 name="phone"
//                                 type="tel"
//                                 autoComplete="tel"
//                                 required
//                                 value={formData.phone}
//                                 onChange={handleInputChange}
//                                 className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 sm:text-sm transition-colors
//                                   ${
//                                     formErrors.phone
//                                       ? "border-red-500"
//                                       : "border-gray-300"
//                                   }`}
//                                 placeholder="+91 98765 43210"
//                                 disabled={isLoading}
//                               />
//                               {formErrors.phone && (
//                                 <p className="mt-1 text-sm text-red-600">
//                                   {formErrors.phone}
//                                 </p>
//                               )}
//                             </div>
//                           </div>

//                           <div>
//                             <label
//                               htmlFor="password"
//                               className="block text-sm font-medium text-gray-700"
//                             >
//                               Password
//                             </label>
//                             <div className="mt-1 relative">
//                               <input
//                                 id="password"
//                                 name="password"
//                                 type={showPassword ? "text" : "password"}
//                                 autoComplete="new-password"
//                                 required
//                                 value={formData.password}
//                                 onChange={handleInputChange}
//                                 className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 sm:text-sm transition-colors
//                                   ${
//                                     formErrors.password
//                                       ? "border-red-500"
//                                       : "border-gray-300"
//                                   }`}
//                                 placeholder="••••••••"
//                                 disabled={isLoading}
//                               />
//                               <button
//                                 type="button"
//                                 onClick={() => setShowPassword(!showPassword)}
//                                 className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
//                               >
//                                 {showPassword ? (
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     className="h-5 w-5"
//                                     viewBox="0 0 20 20"
//                                     fill="currentColor"
//                                   >
//                                     <path
//                                       fillRule="evenodd"
//                                       d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z"
//                                       clipRule="evenodd"
//                                     />
//                                     <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
//                                   </svg>
//                                 ) : (
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     className="h-5 w-5"
//                                     viewBox="0 0 20 20"
//                                     fill="currentColor"
//                                   >
//                                     <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
//                                     <path
//                                       fillRule="evenodd"
//                                       d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
//                                       clipRule="evenodd"
//                                     />
//                                   </svg>
//                                 )}
//                               </button>
//                               {formErrors.password && (
//                                 <p className="mt-1 text-sm text-red-600">
//                                   {formErrors.password}
//                                 </p>
//                               )}
//                             </div>
//                             <PasswordStrengthIndicator />
//                             <p className="mt-1 text-xs text-gray-500">
//                               Must be at least 8 characters with letters,
//                               numbers, and symbols.
//                             </p>
//                           </div>

//                           <div>
//                             <label
//                               htmlFor="confirmPassword"
//                               className="block text-sm font-medium text-gray-700"
//                             >
//                               Confirm Password
//                             </label>
//                             <div className="mt-1">
//                               <input
//                                 id="confirmPassword"
//                                 name="confirmPassword"
//                                 type="password"
//                                 autoComplete="new-password"
//                                 required
//                                 value={formData.confirmPassword}
//                                 onChange={handleInputChange}
//                                 className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:border-gray-500 sm:text-sm transition-colors
//                                   ${
//                                     formErrors.confirmPassword ||
//                                     (!passwordsMatch &&
//                                       formData.confirmPassword)
//                                       ? "border-red-500"
//                                       : "border-gray-300"
//                                   }`}
//                                 placeholder="••••••••"
//                                 disabled={isLoading}
//                               />
//                               {formErrors.confirmPassword && (
//                                 <p className="mt-1 text-sm text-red-600">
//                                   {formErrors.confirmPassword}
//                                 </p>
//                               )}
//                               {!passwordsMatch &&
//                                 formData.confirmPassword &&
//                                 !formErrors.confirmPassword && (
//                                   <p className="mt-1 text-sm text-red-600">
//                                     Passwords do not match
//                                   </p>
//                                 )}
//                             </div>
//                           </div>

//                           <div className="flex items-center">
//                             <input
//                               id="terms"
//                               name="terms"
//                               type="checkbox"
//                               required
//                               className="h-4 w-4 text-gray-700 focus:ring-gray-500 border-gray-300 rounded"
//                               disabled={isLoading}
//                             />
//                             <label
//                               htmlFor="terms"
//                               className="ml-2 block text-sm text-gray-700"
//                             >
//                               I agree to the{" "}
//                               <Link
//                                 to="/terms"
//                                 className="font-medium text-gray-800 hover:text-gray-900 underline"
//                               >
//                                 Terms of Service
//                               </Link>{" "}
//                               and{" "}
//                               <Link
//                                 to="/privacy"
//                                 className="font-medium text-gray-800 hover:text-gray-900 underline"
//                               >
//                                 Privacy Policy
//                               </Link>
//                             </label>
//                           </div>

//                           <div>
//                             <button
//                               type="submit"
//                               className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-md text-base font-medium text-white bg-gray-800 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-600 transition-colors"
//                               disabled={isLoading}
//                             >
//                               {isLoading ? (
//                                 <svg
//                                   className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   fill="none"
//                                   viewBox="0 0 24 24"
//                                 >
//                                   <circle
//                                     className="opacity-25"
//                                     cx="12"
//                                     cy="12"
//                                     r="10"
//                                     stroke="currentColor"
//                                     strokeWidth="4"
//                                   ></circle>
//                                   <path
//                                     className="opacity-75"
//                                     fill="currentColor"
//                                     d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                                   ></path>
//                                 </svg>
//                               ) : null}
//                               Create Account
//                             </button>
//                           </div>

//                           <div className="mt-6">
//                             <div className="relative">
//                               <div className="absolute inset-0 flex items-center">
//                                 <div className="w-full border-t border-gray-300" />
//                               </div>
//                               <div className="relative flex justify-center text-sm">
//                                 <span className="px-2 bg-white text-gray-500">
//                                   Or continue with
//                                 </span>
//                               </div>
//                             </div>

//                             <div className="mt-6">
//                               <button
//                                 type="button"
//                                 onClick={handleGoogleSignIn}
//                                 className="w-full inline-flex justify-center py-3 px-4 border border-gray-300 rounded-lg shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
//                                 disabled={isLoading}
//                               >
//                                 <svg
//                                   className="h-5 w-5 text-[#4285F4]"
//                                   fill="currentColor"
//                                   viewBox="0 0 24 24"
//                                 >
//                                   <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
//                                 </svg>
//                                 <span className="ml-2">
//                                   Sign up with Google
//                                 </span>
//                               </button>
//                             </div>
//                           </div>

//                           <div className="mt-6 text-center">
//                             <p className="text-sm text-gray-600">
//                               Already have an account?{" "}
//                               <button
//                                 type="button"
//                                 onClick={() => setActiveTab("login")}
//                                 className="font-medium text-gray-800 hover:text-gray-900 underline"
//                                 disabled={isLoading}
//                               >
//                                 Sign in
//                               </button>
//                             </p>
//                           </div>
//                         </form>
//                       )}
//                     </motion.div>
//                   </AnimatePresence>
//                 </div>

//                 {/* Right side - Info */}
//                 <div className="hidden md:block md:col-span-2 bg-gradient-to-br from-gray-700 to-gray-900 relative">
//                   <div className="absolute inset-0 overflow-hidden opacity-20">
//                     <svg
//                       className="absolute left-0 max-w-none h-full"
//                       width="100%"
//                       height="100%"
//                       preserveAspectRatio="xMidYMid slice"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <pattern
//                         id="pattern"
//                         width="100"
//                         height="100"
//                         patternUnits="userSpaceOnUse"
//                         patternTransform="rotate(10)"
//                       >
//                         <path
//                           d="M0 100V0l50 50z"
//                           fill="none"
//                           stroke="white"
//                           strokeWidth="0.5"
//                         />
//                       </pattern>
//                       <rect width="100%" height="100%" fill="url(#pattern)" />
//                     </svg>
//                   </div>

//                   <div className="relative flex flex-col items-center justify-center h-full px-8 py-12 text-white text-center">
//                     <img
//                       src="/images/npsc-logo-white.png"
//                       alt="NPSC Coaching"
//                       className="h-20 mb-6"
//                     />

//                     <h3 className="text-2xl font-bold mb-6">
//                       {activeTab === "login"
//                         ? "Welcome Back!"
//                         : "Join Our Community"}
//                     </h3>

//                     <p className="mb-8 text-gray-100 text-lg">
//                       {activeTab === "login"
//                         ? "Log in to access your NPSC coaching dashboard and continue your preparation journey."
//                         : "Start your NPSC preparation with expert guidance and comprehensive resources."}
//                     </p>

//                     <div className="space-y-4 mb-8 text-left">
//                       <div className="flex items-center bg-gray-800 bg-opacity-40 rounded-lg p-3 shadow">
//                         <svg
//                           className="h-8 w-8 mr-3 text-green-400 flex-shrink-0"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//                           />
//                         </svg>
//                         <span>Expert Faculty & Personalized Mentorship</span>
//                       </div>
//                       <div className="flex items-center bg-gray-800 bg-opacity-40 rounded-lg p-3 shadow">
//                         <svg
//                           className="h-8 w-8 mr-3 text-green-400 flex-shrink-0"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//                           />
//                         </svg>
//                         <span>Comprehensive Study Materials</span>
//                       </div>
//                       <div className="flex items-center bg-gray-800 bg-opacity-40 rounded-lg p-3 shadow">
//                         <svg
//                           className="h-8 w-8 mr-3 text-green-400 flex-shrink-0"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//                           />
//                         </svg>
//                         <span>Regular Test Series & Mock Exams</span>
//                       </div>
//                     </div>

//                     <div className="mt-auto">
//                       <div className="flex justify-center mb-4">
//                         <div className="flex -space-x-2 overflow-hidden">
//                           <img
//                             className="inline-block h-10 w-10 rounded-full ring-2 ring-white"
//                             src="/images/testimonials/user1.jpg"
//                             alt=""
//                           />
//                           <img
//                             className="inline-block h-10 w-10 rounded-full ring-2 ring-white"
//                             src="/images/testimonials/user2.jpg"
//                             alt=""
//                           />
//                           <img
//                             className="inline-block h-10 w-10 rounded-full ring-2 ring-white"
//                             src="/images/testimonials/user3.jpg"
//                             alt=""
//                           />
//                           <div className="inline-block h-10 w-10 rounded-full ring-2 ring-white bg-gray-600 flex items-center justify-center text-white text-xs font-medium">
//                             +50
//                           </div>
//                         </div>
//                       </div>
//                       <p className="text-sm">
//                         Join thousands of successful NPSC aspirants!
//                       </p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </motion.div>
//           </div>

//           {/* Testimonial Section */}
//           <div className="mt-16 bg-white rounded-xl shadow-lg overflow-hidden">
//             <div className="relative bg-gray-800 py-10 px-6 md:py-16 md:px-12">
//               <div className="relative z-10 max-w-3xl mx-auto text-center">
//                 <svg
//                   className="mx-auto h-12 w-12 text-gray-400 mb-4"
//                   fill="currentColor"
//                   viewBox="0 0 32 32"
//                   aria-hidden="true"
//                 >
//                   <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
//                 </svg>
//                 <p className="text-xl text-white">
//                   "The guidance and resources provided by NPSC Coaching were
//                   instrumental in my success. The comprehensive study material,
//                   regular test series, and personal mentorship helped me secure
//                   a top rank in the NPSC examination."
//                 </p>
//                 <div className="mt-6">
//                   <div className="flex items-center justify-center">
//                     <img
//                       className="h-12 w-12 rounded-full border-2 border-white"
//                       src="/images/testimonials/featured.jpg"
//                       alt="Testimonial"
//                     />
//                     <div className="ml-4 text-left">
//                       <p className="text-base font-medium text-white">
//                         Thejangulie Zao
//                       </p>
//                       <p className="text-sm text-gray-300">Rank 7, NPSC 2023</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               {/* Background pattern */}
//               <div className="absolute inset-0 opacity-10">
//                 <svg
//                   className="absolute right-0 bottom-0 -mb-48 -mr-88 opacity-50"
//                   width="774"
//                   height="772"
//                   fill="none"
//                   viewBox="0 0 774 772"
//                 >
//                   <defs>
//                     <pattern
//                       id="morepattern"
//                       x="0"
//                       y="0"
//                       width="20"
//                       height="20"
//                       patternUnits="userSpaceOnUse"
//                     >
//                       <rect x="0" y="0" width="4" height="4" fill="white" />
//                     </pattern>
//                   </defs>
//                   <rect width="774" height="772" fill="url(#morepattern)" />
//                 </svg>
//               </div>
//             </div>
//           </div>

//           {/* Trust Indicators */}
//           <div className="mt-16 mb-6 grid grid-cols-2 md:grid-cols-4 gap-8">
//             <div className="bg-white px-6 py-8 rounded-xl shadow-md text-center">
//               <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 text-gray-700 mx-auto mb-4">
//                 <svg
//                   className="h-6 w-6"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-lg font-semibold text-gray-800 mb-2">
//                 Secure Platform
//               </h3>
//               <p className="text-sm text-gray-600">
//                 Your data is encrypted and protected
//               </p>
//             </div>

//             <div className="bg-white px-6 py-8 rounded-xl shadow-md text-center">
//               <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 text-gray-700 mx-auto mb-4">
//                 <svg
//                   className="h-6 w-6"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-lg font-semibold text-gray-800 mb-2">
//                 10,000+ Students
//               </h3>
//               <p className="text-sm text-gray-600">
//                 Join our growing community
//               </p>
//             </div>

//             <div className="bg-white px-6 py-8 rounded-xl shadow-md text-center">
//               <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 text-gray-700 mx-auto mb-4">
//                 <svg
//                   className="h-6 w-6"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-lg font-semibold text-gray-800 mb-2">
//                 Expert Educators
//               </h3>
//               <p className="text-sm text-gray-600">
//                 Learn from experienced faculty
//               </p>
//             </div>

//             <div className="bg-white px-6 py-8 rounded-xl shadow-md text-center">
//               <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 text-gray-700 mx-auto mb-4">
//                 <svg
//                   className="h-6 w-6"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-lg font-semibold text-gray-800 mb-2">
//                 500+ Selections
//               </h3>
//               <p className="text-sm text-gray-600">
//                 Proven track record of success
//               </p>
//             </div>
//           </div>

//           {/* FAQ Section - Collapsible */}
//           <div className="mt-12 bg-white rounded-xl shadow-lg overflow-hidden">
//             <div className="px-6 py-8 sm:p-10">
//               <h2 className="text-2xl font-bold text-gray-800 text-center mb-8">
//                 Frequently Asked Questions
//               </h2>

//               <div className="space-y-4">
//                 {[
//                   {
//                     question: "What are the benefits of creating an account?",
//                     answer:
//                       "Creating an account gives you access to our comprehensive study materials, test series, performance analytics, and personalized recommendations for your NPSC preparation.",
//                   },
//                   {
//                     question: "How do I reset my password?",
//                     answer:
//                       "You can reset your password by clicking on the 'Forgot Password' link on the login page. We'll send you an email with instructions to create a new password.",
//                   },
//                   {
//                     question: "Is my personal information secure?",
//                     answer:
//                       "Yes, we take data security seriously. Your personal information is encrypted and stored securely. We never share your details with third parties without your consent.",
//                   },
//                   {
//                     question: "Can I access the content on mobile devices?",
//                     answer:
//                       "Yes, our platform is fully responsive and optimized for all devices including smartphones and tablets, so you can study on the go.",
//                   },
//                 ].map((faq, index) => (
//                   <div
//                     key={index}
//                     className="border border-gray-200 rounded-lg overflow-hidden"
//                   >
//                     <details className="group">
//                       <summary className="flex justify-between items-center font-medium cursor-pointer p-4 bg-gray-50 hover:bg-gray-100">
//                         <span className="text-gray-800">{faq.question}</span>
//                         <span className="transition group-open:rotate-180">
//                           <svg
//                             fill="none"
//                             height="24"
//                             shape-rendering="geometricPrecision"
//                             stroke="currentColor"
//                             stroke-linecap="round"
//                             stroke-linejoin="round"
//                             stroke-width="1.5"
//                             viewBox="0 0 24 24"
//                             width="24"
//                             className="text-gray-600"
//                           >
//                             <path d="M6 9l6 6 6-6"></path>
//                           </svg>
//                         </span>
//                       </summary>
//                       <p className="text-gray-600 p-4 text-sm">{faq.answer}</p>
//                     </details>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* Contact & CTA */}
//           <div className="mt-16 mb-8 text-center">
//             <p className="text-gray-600 mb-8">
//               Need help? Contact our support team at{" "}
//               <a
//                 href="mailto:support@npsccoaching.com"
//                 className="font-medium text-gray-800 hover:underline"
//               >
//                 support@npsccoaching.com
//               </a>
//             </p>

//             <button
//               onClick={() => {
//                 setActiveTab("register");
//                 window.scrollTo({ top: 0, behavior: "smooth" });
//               }}
//               className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-gray-800 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors shadow-md"
//             >
//               Start Your Preparation Today
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="h-5 w-5 ml-2"
//                 viewBox="0 0 20 20"
//                 fill="currentColor"
//               >
//                 <path
//                   fillRule="evenodd"
//                   d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
//                   clipRule="evenodd"
//                 />
//               </svg>
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AuthPage;
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  sendPasswordResetEmail,
} from "firebase/auth";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { auth } from "../firebaseConfig";
import { CONSTANTS } from "../constants/Constants";

const AuthPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(
    location.pathname === "/register" ? "register" : "login"
  );
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const googleProvider = new GoogleAuthProvider();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    loginEmail: "",
    loginPassword: "",
  });
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeTab]);

  // Update URL based on active tab without reload
  useEffect(() => {
    const path = activeTab === "register" ? "/register" : "/login";
    if (location.pathname !== path) {
      window.history.pushState({}, "", path);
    }
  }, [activeTab, location.pathname]);

  // Check password strength
  useEffect(() => {
    if (!formData.password) {
      setPasswordStrength(0);
      return;
    }

    let strength = 0;
    if (formData.password.length >= 8) strength += 1;
    if (/[A-Z]/.test(formData.password)) strength += 1;
    if (/[0-9]/.test(formData.password)) strength += 1;
    if (/[^A-Za-z0-9]/.test(formData.password)) strength += 1;

    setPasswordStrength(strength);
  }, [formData.password]);

  // Check if passwords match
  useEffect(() => {
    if (formData.confirmPassword) {
      setPasswordsMatch(formData.password === formData.confirmPassword);
    }
  }, [formData.password, formData.confirmPassword]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error for this field when user starts typing again
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: "",
      });
    }
  };

  const validateLoginForm = () => {
    const errors = {};
    if (!formData.loginEmail) errors.loginEmail = "Email is required";
    if (!formData.loginPassword) errors.loginPassword = "Password is required";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateRegisterForm = () => {
    const errors = {};
    if (!formData.firstName) errors.firstName = "First name is required";
    if (!formData.lastName) errors.lastName = "Last name is required";
    if (!formData.email) errors.email = "Email is required";
    if (!formData.phone) errors.phone = "Phone number is required";
    if (!formData.password) errors.password = "Password is required";
    if (formData.password.length < 8)
      errors.password = "Password must be at least 8 characters";
    if (passwordStrength < 3) errors.password = "Password is too weak";
    if (!formData.confirmPassword)
      errors.confirmPassword = "Please confirm your password";
    if (formData.password !== formData.confirmPassword)
      errors.confirmPassword = "Passwords do not match";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleForgotPassword = async () => {
    if (!formData.loginEmail) {
      setFormErrors({ ...formErrors, loginEmail: "Please enter your email" });
      return;
    }

    try {
      setIsLoading(true);
      await sendPasswordResetEmail(auth, formData.loginEmail);
      toast.success("Password reset email sent! Check your inbox.");
    } catch (error) {
      toast.error("Failed to send reset email: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();

    if (!validateLoginForm()) return;

    try {
      setIsLoading(true);

      // Sign in with Firebase
      const userCredential = await signInWithEmailAndPassword(
        auth,
        formData.loginEmail,
        formData.loginPassword
      );

      const user = userCredential.user;

      // Fetch additional user data from MongoDB
      const response = await axios.get(
        `${CONSTANTS.APIURL}/api/users/${user.uid}`
      );

      // Store user data in localStorage or context
      if (rememberMe) {
        localStorage.setItem(
          "user",
          JSON.stringify({
            uid: user.uid,
            email: user.email,
            ...response.data,
          })
        );
      } else {
        sessionStorage.setItem(
          "user",
          JSON.stringify({
            uid: user.uid,
            email: user.email,
            ...response.data,
          })
        );
      }

      toast.success("Login successful!");

      // Redirect to dashboard
      setTimeout(() => {
        navigate("/");
      }, 1500);
    } catch (error) {
      console.error("Login error:", error);

      let errorMessage = "Failed to sign in";
      if (error.code === "auth/invalid-email") {
        errorMessage = "Invalid email address";
      } else if (error.code === "auth/invalid-credential") {
        errorMessage = "Invalid email or password";
      } else if (error.code === "auth/too-many-requests") {
        errorMessage = "Too many attempts. Try again later";
      }

      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      setIsLoading(true);

      // Sign in with Google
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      // Check if user exists in our database
      try {
        await axios.get(`${CONSTANTS.APIURL}/api/users/${user.uid}`);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // User doesn't exist, create new user in MongoDB
          const userData = {
            uid: user.uid,
            firstName: user.displayName ? user.displayName.split(" ")[0] : "",
            lastName: user.displayName
              ? user.displayName.split(" ").slice(1).join(" ")
              : "",
            email: user.email,
            phone: user.phoneNumber || "N/A",
            authProvider: "google",
            createdAt: new Date(),
          };

          await axios.post(`${CONSTANTS.APIURL}/api/users`, userData);
        }
      }

      // Store user data
      localStorage.setItem(
        "user",
        JSON.stringify({
          uid: user.uid,
          email: user.email,
          firstName: user.displayName ? user.displayName.split(" ")[0] : "",
          lastName: user.displayName
            ? user.displayName.split(" ").slice(1).join(" ")
            : "",
          photoURL: user.photoURL,
        })
      );

      toast.success("Login successful!");

      // Redirect to dashboard
      setTimeout(() => {
        navigate("/");
      }, 1500);
    } catch (error) {
      console.error("Google sign-in error:", error);
      toast.error("Failed to sign in with Google: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();

    if (!validateRegisterForm()) return;

    try {
      setIsLoading(true);

      // Create user in Firebase
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );

      const user = userCredential.user;

      // Create user in MongoDB
      const userData = {
        uid: user.uid,
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        authProvider: "email",
        createdAt: new Date(),
      };

      await axios.post(`${CONSTANTS.APIURL}/api/users`, userData);

      toast.success("Account created successfully!");

      // Automatically log in and redirect
      setTimeout(() => {
        setActiveTab("login");
        setFormData({
          ...formData,
          loginEmail: formData.email,
          loginPassword: formData.password,
        });
      }, 1500);
    } catch (error) {
      console.error("Registration error:", error);

      let errorMessage = "Failed to create account";
      if (error.code === "auth/email-already-in-use") {
        errorMessage = "Email already in use";
      } else if (error.code === "auth/invalid-email") {
        errorMessage = "Invalid email address";
      } else if (error.code === "auth/weak-password") {
        errorMessage = "Password is too weak";
      }

      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  // Password strength indicator component
  const PasswordStrengthIndicator = () => {
    const strengthLabels = ["Weak", "Fair", "Good", "Strong"];
    const strengthColors = ["#f87171", "#fbbf24", "#34d399", "#2C5282"];

    return (
      <div className="mt-1">
        <div className="w-full h-1 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full transition-all duration-300 ease-in-out"
            style={{
              width: `${(passwordStrength / 4) * 100}%`,
              backgroundColor:
                strengthColors[passwordStrength - 1] || "#f3f4f6",
            }}
          />
        </div>
        {formData.password && (
          <p
            className="text-xs mt-1"
            style={{ color: strengthColors[passwordStrength - 1] || "#6b7280" }}
          >
            {passwordStrength > 0
              ? strengthLabels[passwordStrength - 1]
              : "Too weak"}
          </p>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-[#2C5282]/10 pt-4 pb-12">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center">
          <div style={{ height: 100 }} />
          {/* Logo and Header */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#fff] to-white-600 rounded-2xl mb-6 shadow-lg">
              <img
                className="h-14 w-auto"
                src={require("../assets/logo.png")}
                alt="SKYSEP"
              />
            </div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-[#2C5282] to-blue-600 bg-clip-text text-transparent mb-3">
              SKYSEP
            </h1>
            <h2 className="text-2xl font-bold text-gray-800 mb-3">
              {activeTab === "login" ? "Welcome Back" : "Join Our Platform"}
            </h2>
            <p className="text-lg text-[#2C5282] font-semibold mb-2">
              Transforming Education for a Brighter Tomorrow
            </p>
            <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed">
              {activeTab === "login"
                ? "Sign in to access your dashboard, learning materials, and innovative educational tools that are reshaping the future of learning."
                : "Join SKYSEP Holistics Pvt. Ltd., based in Bengaluru, and be part of redefining education through innovation, collaboration, and empowerment."}
            </p>
          </div>

          {/* Auth Card */}
          <div className="w-full max-w-6xl">
            <motion.div
              className="bg-white rounded-2xl shadow-xl overflow-hidden border border-[#2C5282]/10"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className="md:grid md:grid-cols-5">
                {/* Left side - Form */}
                <div className="md:col-span-3 p-6 sm:p-10">
                  {/* Tab Switcher */}
                  <div className="flex border-b border-gray-200 mb-8">
                    <button
                      className={`py-4 px-6 text-center font-medium text-lg transition-colors relative ${
                        activeTab === "login"
                          ? "text-[#2C5282]"
                          : "text-gray-500 hover:text-gray-700"
                      }`}
                      onClick={() => setActiveTab("login")}
                      disabled={isLoading}
                    >
                      Login
                      {activeTab === "login" && (
                        <motion.div
                          className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#2C5282]"
                          layoutId="activeTab"
                        />
                      )}
                    </button>
                    <button
                      className={`py-4 px-6 text-center font-medium text-lg transition-colors relative ${
                        activeTab === "register"
                          ? "text-[#2C5282]"
                          : "text-gray-500 hover:text-gray-700"
                      }`}
                      onClick={() => setActiveTab("register")}
                      disabled={isLoading}
                    >
                      Register
                      {activeTab === "register" && (
                        <motion.div
                          className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#2C5282]"
                          layoutId="activeTab"
                        />
                      )}
                    </button>
                  </div>

                  <AnimatePresence mode="wait">
                    <motion.div
                      key={activeTab}
                      initial={{
                        opacity: 0,
                        x: activeTab === "login" ? -20 : 20,
                      }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: activeTab === "login" ? 20 : -20 }}
                      transition={{ duration: 0.3 }}
                    >
                      {/* Login Form */}
                      {activeTab === "login" && (
                        <form
                          onSubmit={handleLoginSubmit}
                          className="space-y-6"
                        >
                          <div>
                            <label
                              htmlFor="loginEmail"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Email Address
                            </label>
                            <div className="mt-1">
                              <input
                                id="loginEmail"
                                name="loginEmail"
                                type="email"
                                autoComplete="email"
                                required
                                value={formData.loginEmail}
                                onChange={handleInputChange}
                                className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#2C5282] focus:border-[#2C5282] sm:text-sm transition-colors
                                  ${
                                    formErrors.loginEmail
                                      ? "border-red-500"
                                      : "border-gray-300"
                                  }`}
                                placeholder="your.email@example.com"
                                disabled={isLoading}
                              />
                              {formErrors.loginEmail && (
                                <p className="mt-1 text-sm text-red-600">
                                  {formErrors.loginEmail}
                                </p>
                              )}
                            </div>
                          </div>

                          <div>
                            <div className="flex items-center justify-between">
                              <label
                                htmlFor="loginPassword"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Password
                              </label>
                              <button
                                type="button"
                                onClick={handleForgotPassword}
                                className="text-sm font-medium text-[#2C5282] hover:text-blue-700 transition-colors"
                                disabled={isLoading}
                              >
                                Forgot password?
                              </button>
                            </div>
                            <div className="mt-1 relative">
                              <input
                                id="loginPassword"
                                name="loginPassword"
                                type={showPassword ? "text" : "password"}
                                autoComplete="current-password"
                                required
                                value={formData.loginPassword}
                                onChange={handleInputChange}
                                className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#2C5282] focus:border-[#2C5282] sm:text-sm transition-colors
                                  ${
                                    formErrors.loginPassword
                                      ? "border-red-500"
                                      : "border-gray-300"
                                  }`}
                                placeholder="••••••••"
                                disabled={isLoading}
                              />
                              <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                              >
                                {showPassword ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z"
                                      clipRule="evenodd"
                                    />
                                    <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
                                  </svg>
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                    <path
                                      fillRule="evenodd"
                                      d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                )}
                              </button>
                              {formErrors.loginPassword && (
                                <p className="mt-1 text-sm text-red-600">
                                  {formErrors.loginPassword}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="flex items-center justify-between">
                            <div className="flex items-center">
                              <input
                                id="remember-me"
                                name="remember-me"
                                type="checkbox"
                                checked={rememberMe}
                                onChange={(e) =>
                                  setRememberMe(e.target.checked)
                                }
                                className="h-4 w-4 text-[#2C5282] focus:ring-[#2C5282] border-gray-300 rounded"
                                disabled={isLoading}
                              />
                              <label
                                htmlFor="remember-me"
                                className="ml-2 block text-sm text-gray-700"
                              >
                                Remember me
                              </label>
                            </div>
                          </div>

                          <div>
                            <button
                              type="submit"
                              className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-md text-base font-medium text-white bg-gradient-to-r from-[#2C5282] to-blue-600 hover:from-[#2A4A7A] hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2C5282] transition-all duration-200"
                              disabled={isLoading}
                            >
                              {isLoading ? (
                                <svg
                                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  ></path>
                                </svg>
                              ) : null}
                              Sign in to SKYSEP
                            </button>
                          </div>

                          <div className="mt-6">
                            <div className="relative">
                              <div className="absolute inset-0 flex items-center">
                                <div className="w-full border-t border-gray-300" />
                              </div>
                              <div className="relative flex justify-center text-sm">
                                <span className="px-2 bg-white text-gray-500">
                                  Or continue with
                                </span>
                              </div>
                            </div>

                            <div className="mt-6">
                              <button
                                type="button"
                                onClick={handleGoogleSignIn}
                                className="w-full inline-flex justify-center py-3 px-4 border border-gray-300 rounded-lg shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                                disabled={isLoading}
                              >
                                <svg
                                  className="h-5 w-5 text-[#4285F4]"
                                  fill="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
                                </svg>
                                <span className="ml-2">
                                  Sign in with Google
                                </span>
                              </button>
                            </div>
                          </div>

                          <div className="mt-6 text-center">
                            <p className="text-sm text-gray-600">
                              Don't have an account?{" "}
                              <button
                                type="button"
                                onClick={() => setActiveTab("register")}
                                className="font-medium text-[#2C5282] hover:text-blue-700 underline"
                                disabled={isLoading}
                              >
                                Register now
                              </button>
                            </p>
                          </div>
                        </form>
                      )}

                      {/* Register Form */}
                      {activeTab === "register" && (
                        <form
                          onSubmit={handleRegisterSubmit}
                          className="space-y-6"
                        >
                          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                            <div>
                              <label
                                htmlFor="firstName"
                                className="block text-sm font-medium text-gray-700"
                              >
                                First Name
                              </label>
                              <div className="mt-1">
                                <input
                                  id="firstName"
                                  name="firstName"
                                  type="text"
                                  autoComplete="given-name"
                                  required
                                  value={formData.firstName}
                                  onChange={handleInputChange}
                                  className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#2C5282] focus:border-[#2C5282] sm:text-sm transition-colors
                                    ${
                                      formErrors.firstName
                                        ? "border-red-500"
                                        : "border-gray-300"
                                    }`}
                                  placeholder="John"
                                  disabled={isLoading}
                                />
                                {formErrors.firstName && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {formErrors.firstName}
                                  </p>
                                )}
                              </div>
                            </div>

                            <div>
                              <label
                                htmlFor="lastName"
                                className="block text-sm font-medium text-gray-700"
                              >
                                Last Name
                              </label>
                              <div className="mt-1">
                                <input
                                  id="lastName"
                                  name="lastName"
                                  type="text"
                                  autoComplete="family-name"
                                  required
                                  value={formData.lastName}
                                  onChange={handleInputChange}
                                  className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#2C5282] focus:border-[#2C5282] sm:text-sm transition-colors
                                    ${
                                      formErrors.lastName
                                        ? "border-red-500"
                                        : "border-gray-300"
                                    }`}
                                  placeholder="Doe"
                                  disabled={isLoading}
                                />
                                {formErrors.lastName && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {formErrors.lastName}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>

                          <div>
                            <label
                              htmlFor="email"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Email Address
                            </label>
                            <div className="mt-1">
                              <input
                                id="email"
                                name="email"
                                type="email"
                                autoComplete="email"
                                required
                                value={formData.email}
                                onChange={handleInputChange}
                                className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#2C5282] focus:border-[#2C5282] sm:text-sm transition-colors
                                  ${
                                    formErrors.email
                                      ? "border-red-500"
                                      : "border-gray-300"
                                  }`}
                                placeholder="your.email@example.com"
                                disabled={isLoading}
                              />
                              {formErrors.email && (
                                <p className="mt-1 text-sm text-red-600">
                                  {formErrors.email}
                                </p>
                              )}
                            </div>
                          </div>

                          <div>
                            <label
                              htmlFor="phone"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Phone Number
                            </label>
                            <div className="mt-1">
                              <input
                                id="phone"
                                name="phone"
                                type="tel"
                                autoComplete="tel"
                                required
                                value={formData.phone}
                                onChange={handleInputChange}
                                className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#2C5282] focus:border-[#2C5282] sm:text-sm transition-colors
                                  ${
                                    formErrors.phone
                                      ? "border-red-500"
                                      : "border-gray-300"
                                  }`}
                                placeholder="+91 98765 43210"
                                disabled={isLoading}
                              />
                              {formErrors.phone && (
                                <p className="mt-1 text-sm text-red-600">
                                  {formErrors.phone}
                                </p>
                              )}
                            </div>
                          </div>

                          <div>
                            <label
                              htmlFor="password"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Password
                            </label>
                            <div className="mt-1 relative">
                              <input
                                id="password"
                                name="password"
                                type={showPassword ? "text" : "password"}
                                autoComplete="new-password"
                                required
                                value={formData.password}
                                onChange={handleInputChange}
                                className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#2C5282] focus:border-[#2C5282] sm:text-sm transition-colors
                                  ${
                                    formErrors.password
                                      ? "border-red-500"
                                      : "border-gray-300"
                                  }`}
                                placeholder="••••••••"
                                disabled={isLoading}
                              />
                              <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
                              >
                                {showPassword ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z"
                                      clipRule="evenodd"
                                    />
                                    <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
                                  </svg>
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                    <path
                                      fillRule="evenodd"
                                      d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                )}
                              </button>
                              {formErrors.password && (
                                <p className="mt-1 text-sm text-red-600">
                                  {formErrors.password}
                                </p>
                              )}
                            </div>
                            <PasswordStrengthIndicator />
                            <p className="mt-1 text-xs text-gray-500">
                              Must be at least 8 characters with letters,
                              numbers, and symbols.
                            </p>
                          </div>

                          <div>
                            <label
                              htmlFor="confirmPassword"
                              className="block text-sm font-medium text-gray-700"
                            >
                              Confirm Password
                            </label>
                            <div className="mt-1">
                              <input
                                id="confirmPassword"
                                name="confirmPassword"
                                type="password"
                                autoComplete="new-password"
                                required
                                value={formData.confirmPassword}
                                onChange={handleInputChange}
                                className={`appearance-none block w-full px-4 py-3 border rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#2C5282] focus:border-[#2C5282] sm:text-sm transition-colors
                                  ${
                                    formErrors.confirmPassword ||
                                    (!passwordsMatch &&
                                      formData.confirmPassword)
                                      ? "border-red-500"
                                      : "border-gray-300"
                                  }`}
                                placeholder="••••••••"
                                disabled={isLoading}
                              />
                              {formErrors.confirmPassword && (
                                <p className="mt-1 text-sm text-red-600">
                                  {formErrors.confirmPassword}
                                </p>
                              )}
                              {!passwordsMatch &&
                                formData.confirmPassword &&
                                !formErrors.confirmPassword && (
                                  <p className="mt-1 text-sm text-red-600">
                                    Passwords do not match
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="flex items-center">
                            <input
                              id="terms"
                              name="terms"
                              type="checkbox"
                              required
                              className="h-4 w-4 text-[#2C5282] focus:ring-[#2C5282] border-gray-300 rounded"
                              disabled={isLoading}
                            />
                            <label
                              htmlFor="terms"
                              className="ml-2 block text-sm text-gray-700"
                            >
                              I agree to the{" "}
                              <Link
                                to="/terms"
                                className="font-medium text-[#2C5282] hover:text-blue-700 underline"
                              >
                                Terms of Service
                              </Link>{" "}
                              and{" "}
                              <Link
                                to="/privacy"
                                className="font-medium text-[#2C5282] hover:text-blue-700 underline"
                              >
                                Privacy Policy
                              </Link>
                            </label>
                          </div>

                          <div>
                            <button
                              type="submit"
                              className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-md text-base font-medium text-white bg-gradient-to-r from-[#2C5282] to-blue-600 hover:from-[#2A4A7A] hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2C5282] transition-all duration-200"
                              disabled={isLoading}
                            >
                              {isLoading ? (
                                <svg
                                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  ></path>
                                </svg>
                              ) : null}
                              Join SKYSEP Community
                            </button>
                          </div>

                          <div className="mt-6">
                            <div className="relative">
                              <div className="absolute inset-0 flex items-center">
                                <div className="w-full border-t border-gray-300" />
                              </div>
                              <div className="relative flex justify-center text-sm">
                                <span className="px-2 bg-white text-gray-500">
                                  Or continue with
                                </span>
                              </div>
                            </div>

                            <div className="mt-6">
                              <button
                                type="button"
                                onClick={handleGoogleSignIn}
                                className="w-full inline-flex justify-center py-3 px-4 border border-gray-300 rounded-lg shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                                disabled={isLoading}
                              >
                                <svg
                                  className="h-5 w-5 text-[#4285F4]"
                                  fill="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" />
                                </svg>
                                <span className="ml-2">
                                  Sign up with Google
                                </span>
                              </button>
                            </div>
                          </div>

                          <div className="mt-6 text-center">
                            <p className="text-sm text-gray-600">
                              Already have an account?{" "}
                              <button
                                type="button"
                                onClick={() => setActiveTab("login")}
                                className="font-medium text-[#2C5282] hover:text-blue-700 underline"
                                disabled={isLoading}
                              >
                                Sign in
                              </button>
                            </p>
                          </div>
                        </form>
                      )}
                    </motion.div>
                  </AnimatePresence>
                </div>

                {/* Right side - Info */}
                <div className="hidden md:block md:col-span-2 bg-gradient-to-br from-[#2C5282] to-blue-800 relative">
                  <div className="absolute inset-0 overflow-hidden opacity-20">
                    <svg
                      className="absolute left-0 max-w-none h-full"
                      width="100%"
                      height="100%"
                      preserveAspectRatio="xMidYMid slice"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <pattern
                        id="pattern"
                        width="100"
                        height="100"
                        patternUnits="userSpaceOnUse"
                        patternTransform="rotate(10)"
                      >
                        <path
                          d="M0 100V0l50 50z"
                          fill="none"
                          stroke="white"
                          strokeWidth="0.5"
                        />
                      </pattern>
                      <rect width="100%" height="100%" fill="url(#pattern)" />
                    </svg>
                  </div>

                  <div className="relative flex flex-col items-center justify-center h-full px-8 py-12 text-white text-center">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-2xl mb-6">
                      <img
                        className="h-14 w-auto"
                        src={require("../assets/logo.png")}
                        alt="SKYSEP"
                      />
                    </div>

                    <h3 className="text-2xl font-bold mb-2">
                      {activeTab === "login"
                        ? "Welcome Back to SKYSEP!"
                        : "Join the Future of Education"}
                    </h3>

                    <p className="text-blue-100 text-sm font-medium mb-6">
                      SKYSEP Holistics Pvt. Ltd. | Bengaluru
                    </p>

                    <p className="mb-8 text-blue-100 text-lg leading-relaxed">
                      {activeTab === "login"
                        ? "Continue your journey in transforming education through innovation, collaboration, and empowerment."
                        : "We're not just changing classrooms—we're shaping the future of learning for students, educators, and institutions alike."}
                    </p>

                    <div className="space-y-4 mb-8 text-left">
                      <div className="flex items-center bg-white/10 backdrop-blur-sm rounded-lg p-4 shadow">
                        <svg
                          className="h-8 w-8 mr-3 text-blue-200 flex-shrink-0"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M13 10V3L4 14h7v7l9-11h-7z"
                          />
                        </svg>
                        <span className="text-blue-100">
                          Innovation-Driven Learning Solutions
                        </span>
                      </div>
                      <div className="flex items-center bg-white/10 backdrop-blur-sm rounded-lg p-4 shadow">
                        <svg
                          className="h-8 w-8 mr-3 text-blue-200 flex-shrink-0"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                          />
                        </svg>
                        <span className="text-blue-100">
                          Collaborative Educational Community
                        </span>
                      </div>
                      <div className="flex items-center bg-white/10 backdrop-blur-sm rounded-lg p-4 shadow">
                        <svg
                          className="h-8 w-8 mr-3 text-blue-200 flex-shrink-0"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                          />
                        </svg>
                        <span className="text-blue-100">
                          Empowering Students & Educators
                        </span>
                      </div>
                    </div>

                    <div className="mt-auto">
                      <div className="flex justify-center mb-4">
                        <div className="flex -space-x-2 overflow-hidden">
                          <div className="inline-block h-10 w-10 rounded-full ring-2 ring-white bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center text-white text-xs font-medium">
                            A
                          </div>
                          <div className="inline-block h-10 w-10 rounded-full ring-2 ring-white bg-gradient-to-br from-indigo-400 to-indigo-600 flex items-center justify-center text-white text-xs font-medium">
                            B
                          </div>
                          <div className="inline-block h-10 w-10 rounded-full ring-2 ring-white bg-gradient-to-br from-purple-400 to-purple-600 flex items-center justify-center text-white text-xs font-medium">
                            C
                          </div>
                          <div className="inline-block h-10 w-10 rounded-full ring-2 ring-white bg-gradient-to-br from-pink-400 to-pink-600 flex items-center justify-center text-white text-xs font-medium">
                            +1K
                          </div>
                        </div>
                      </div>
                      <p className="text-sm text-blue-100">
                        Join thousands transforming education!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Testimonial Section */}
          <div className="mt-16 bg-white rounded-xl shadow-lg overflow-hidden border border-[#2C5282]/10">
            <div className="relative bg-gradient-to-br from-[#2C5282] to-blue-800 py-10 px-6 md:py-16 md:px-12">
              <div className="relative z-10 max-w-3xl mx-auto text-center">
                <svg
                  className="mx-auto h-12 w-12 text-blue-200 mb-4"
                  fill="currentColor"
                  viewBox="0 0 32 32"
                  aria-hidden="true"
                >
                  <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                </svg>
                <p className="text-xl text-white leading-relaxed">
                  "SKYSEP has revolutionized our approach to education. Their
                  innovative platform and collaborative tools have transformed
                  how we engage with students and deliver content. The future of
                  learning is here!"
                </p>
                <div className="mt-6">
                  <div className="flex items-center justify-center">
                    <div className="h-12 w-12 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 border-2 border-white flex items-center justify-center text-white font-bold">
                      Dr
                    </div>
                    <div className="ml-4 text-left">
                      <p className="text-base font-medium text-white">
                        Dr. Priya Sharma
                      </p>
                      <p className="text-sm text-blue-200">
                        Educational Director, Bengaluru
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Background pattern */}
              <div className="absolute inset-0 opacity-10">
                <svg
                  className="absolute right-0 bottom-0 -mb-48 -mr-88 opacity-50"
                  width="774"
                  height="772"
                  fill="none"
                  viewBox="0 0 774 772"
                >
                  <defs>
                    <pattern
                      id="morepattern"
                      x="0"
                      y="0"
                      width="20"
                      height="20"
                      patternUnits="userSpaceOnUse"
                    >
                      <rect x="0" y="0" width="4" height="4" fill="white" />
                    </pattern>
                  </defs>
                  <rect width="774" height="772" fill="url(#morepattern)" />
                </svg>
              </div>
            </div>
          </div>

          {/* Trust Indicators */}
          <div className="mt-16 mb-6 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="bg-white px-6 py-8 rounded-xl shadow-md text-center border border-[#2C5282]/10">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#2C5282]/10 text-[#2C5282] mx-auto mb-4">
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Secure & Private
              </h3>
              <p className="text-sm text-gray-600">
                Enterprise-grade security for your data
              </p>
            </div>

            <div className="bg-white px-6 py-8 rounded-xl shadow-md text-center border border-[#2C5282]/10">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#2C5282]/10 text-[#2C5282] mx-auto mb-4">
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Innovation First
              </h3>
              <p className="text-sm text-gray-600">
                Cutting-edge educational technology
              </p>
            </div>

            <div className="bg-white px-6 py-8 rounded-xl shadow-md text-center border border-[#2C5282]/10">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#2C5282]/10 text-[#2C5282] mx-auto mb-4">
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Growing Community
              </h3>
              <p className="text-sm text-gray-600">
                Students, educators & institutions
              </p>
            </div>

            <div className="bg-white px-6 py-8 rounded-xl shadow-md text-center border border-[#2C5282]/10">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#2C5282]/10 text-[#2C5282] mx-auto mb-4">
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Proven Impact
              </h3>
              <p className="text-sm text-gray-600">
                Transforming educational outcomes
              </p>
            </div>
          </div>

          {/* FAQ Section - Collapsible */}
          <div className="mt-12 bg-white rounded-xl shadow-lg overflow-hidden border border-[#2C5282]/10">
            <div className="px-6 py-8 sm:p-10">
              <h2 className="text-2xl font-bold text-gray-800 text-center mb-8">
                Frequently Asked Questions
              </h2>

              <div className="space-y-4">
                {[
                  {
                    question:
                      "What makes SKYSEP different from other educational platforms?",
                    answer:
                      "SKYSEP focuses on innovation, collaboration, and empowerment. We're not just providing content—we're transforming the entire educational experience through cutting-edge technology and community-driven learning.",
                  },
                  {
                    question: "How do I reset my password?",
                    answer:
                      "You can reset your password by clicking on the 'Forgot Password' link on the login page. We'll send you a secure email with instructions to create a new password.",
                  },
                  {
                    question: "Is my personal information secure with SKYSEP?",
                    answer:
                      "Absolutely. We use enterprise-grade security measures to protect your data. Your personal information is encrypted and stored securely, and we never share your details with third parties without your explicit consent.",
                  },
                  {
                    question: "Can I access SKYSEP on mobile devices?",
                    answer:
                      "Yes! Our platform is fully responsive and optimized for all devices including smartphones and tablets. Learn and collaborate seamlessly across all your devices.",
                  },
                  {
                    question: "What support is available for new users?",
                    answer:
                      "We provide comprehensive onboarding, 24/7 customer support, detailed documentation, and a vibrant community forum to help you get the most out of the SKYSEP platform.",
                  },
                ].map((faq, index) => (
                  <div
                    key={index}
                    className="border border-gray-200 rounded-lg overflow-hidden hover:border-[#2C5282]/30 transition-colors"
                  >
                    <details className="group">
                      <summary className="flex justify-between items-center font-medium cursor-pointer p-4 bg-gray-50 hover:bg-[#2C5282]/5 transition-colors">
                        <span className="text-gray-800">{faq.question}</span>
                        <span className="transition group-open:rotate-180">
                          <svg
                            fill="none"
                            height="24"
                            shape-rendering="geometricPrecision"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                            viewBox="0 0 24 24"
                            width="24"
                            className="text-[#2C5282]"
                          >
                            <path d="M6 9l6 6 6-6"></path>
                          </svg>
                        </span>
                      </summary>
                      <p className="text-gray-600 p-4 text-sm leading-relaxed">
                        {faq.answer}
                      </p>
                    </details>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Company Information Section */}
          <div className="mt-16 bg-gradient-to-br from-[#2C5282]/5 to-blue-50 rounded-xl p-8 md:p-12">
            <div className="text-center max-w-4xl mx-auto">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#fff] to-white-700 rounded-2xl mb-6">
                <img
                  className="h-14 w-auto"
                  src={require("../assets/logo.png")}
                  alt="SKYSEP"
                />
              </div>

              <h2 className="text-3xl font-bold text-gray-800 mb-4">
                About SKYSEP Holistics Pvt. Ltd.
              </h2>

              <p className="text-lg text-[#2C5282] font-semibold mb-6">
                Transforming Education for a Brighter Tomorrow
              </p>

              <p className="text-gray-600 text-lg leading-relaxed mb-8 max-w-3xl mx-auto">
                Based in Bengaluru, SKYSEP Holistics Pvt. Ltd. is redefining
                education through innovation, collaboration, and empowerment.
                We're not just changing classrooms—we're shaping the future of
                learning for students, educators, and institutions alike.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                <div className="bg-white/70 backdrop-blur-sm rounded-lg p-6 border border-[#2C5282]/20">
                  <div className="w-12 h-12 bg-[#2C5282]/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <svg
                      className="w-6 h-6 text-[#2C5282]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 10V3L4 14h7v7l9-11h-7z"
                      />
                    </svg>
                  </div>
                  <h3 className="font-semibold text-gray-800 mb-2">
                    Innovation
                  </h3>
                  <p className="text-sm text-gray-600">
                    Cutting-edge technology driving educational transformation
                  </p>
                </div>

                <div className="bg-white/70 backdrop-blur-sm rounded-lg p-6 border border-[#2C5282]/20">
                  <div className="w-12 h-12 bg-[#2C5282]/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <svg
                      className="w-6 h-6 text-[#2C5282]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                      />
                    </svg>
                  </div>
                  <h3 className="font-semibold text-gray-800 mb-2">
                    Collaboration
                  </h3>
                  <p className="text-sm text-gray-600">
                    Building bridges between students, educators, and
                    institutions
                  </p>
                </div>

                <div className="bg-white/70 backdrop-blur-sm rounded-lg p-6 border border-[#2C5282]/20">
                  <div className="w-12 h-12 bg-[#2C5282]/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <svg
                      className="w-6 h-6 text-[#2C5282]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                      />
                    </svg>
                  </div>
                  <h3 className="font-semibold text-gray-800 mb-2">
                    Empowerment
                  </h3>
                  <p className="text-sm text-gray-600">
                    Enabling every learner to reach their full potential
                  </p>
                </div>
              </div>

              <div className="bg-white/50 backdrop-blur-sm rounded-lg p-6 border border-[#2C5282]/20">
                <div className="flex items-center justify-center mb-4">
                  <svg
                    className="w-6 h-6 text-[#2C5282] mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                  <span className="text-gray-700 font-medium">
                    Headquartered in Bengaluru, India
                  </span>
                </div>
                <p className="text-sm text-gray-600">
                  Serving educational communities globally with localized
                  solutions and global standards.
                </p>
              </div>
            </div>
          </div>

          {/* Contact & CTA */}
          <div className="mt-16 mb-8 text-center">
            <div className="mb-8">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">
                Ready to Transform Education?
              </h3>
              <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
                Join SKYSEP today and be part of the educational revolution.
                Connect with innovators, collaborate with peers, and empower the
                next generation of learners.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
              <button
                onClick={() => {
                  setActiveTab("register");
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-gradient-to-r from-[#2C5282] to-blue-600 hover:from-[#2A4A7A] hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2C5282] transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
                Start Your Journey Today
              </button>

              <Link
                to="/about"
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#2C5282] text-base font-medium rounded-lg text-[#2C5282] bg-white hover:bg-[#2C5282]/5 transition-colors duration-200"
              >
                Learn More About Us
              </Link>
            </div>

            <div className="border-t border-gray-200 pt-8">
              <p className="text-gray-600 mb-4">
                Need assistance? Our support team is here to help!
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm">
                <a
                  href="mailto:support@skysep.com"
                  className="flex items-center font-medium text-[#2C5282] hover:text-blue-700 transition-colors"
                >
                  <svg
                    className="w-4 h-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  support@skysep.com
                </a>
                <a
                  href="tel:+918012345678"
                  className="flex items-center font-medium text-[#2C5282] hover:text-blue-700 transition-colors"
                >
                  <svg
                    className="w-4 h-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                  +91 80 1234 5678
                </a>
                <span className="flex items-center text-gray-500">
                  <svg
                    className="w-4 h-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  24/7 Support Available
                </span>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-12 pt-8 border-t border-gray-200 text-center text-sm text-gray-500">
            <div className="flex flex-col sm:flex-row items-center justify-between">
              <div className="flex items-center mb-4 sm:mb-0">
                <div className="inline-flex items-center justify-center w-8 h-8 bg-gradient-to-br from-[#fff] to-white-700 rounded-lg mr-3">
                  <img
                    className="h-14 w-auto"
                    src={require("../assets/logo.png")}
                    alt="SKYSEP"
                  />
                </div>
                <span className="font-medium text-gray-700">
                  © 2024 SKYSEP Holistics Pvt. Ltd.
                </span>
              </div>
              <div className="flex items-center space-x-6">
                <Link
                  to="/privacy"
                  className="hover:text-[#2C5282] transition-colors"
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/terms"
                  className="hover:text-[#2C5282] transition-colors"
                >
                  Terms of Service
                </Link>
                <Link
                  to="/contact"
                  className="hover:text-[#2C5282] transition-colors"
                >
                  Contact Us
                </Link>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-gray-100">
              <p className="text-xs text-gray-400">
                Transforming Education for a Brighter Tomorrow | Bengaluru,
                India
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
